import {createSelector} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {IShiftTemplatesState} from '@app/core/store/state/shift-templates.state';

const _selectShiftTemplates = (state: IAppState) => state.shiftTemplates;

export const selectCopyingWeek = createSelector(
	_selectShiftTemplates,
	(state: IShiftTemplatesState) => state.copyingWeek,
);
export const selectShiftTemplates = createSelector(
	_selectShiftTemplates,
	(state: IShiftTemplatesState) => state.shiftTemplates,
);
export const selectIsLoadingShiftTemplates = createSelector(
	_selectShiftTemplates,
	(state: IShiftTemplatesState) => state.isLoading,
);
